import {Outlet} from "react-router-dom"

import {useStateProviderValue} from "../context/StateProvider"

import Navigation from "../components/Navigation"

import {GENERATE_FROM_SAMPLE, RESET_DATA} from "../types"

import sampleData from "../sampleData"

const Home = () => {
	const {dispatch} = useStateProviderValue()

	const generateFromSample = () => {
		dispatch({
			type: GENERATE_FROM_SAMPLE,
			data: sampleData,
		})
	}
	const resetData = () => {
		dispatch({
			type: RESET_DATA,
		})
	}

	return (
		<div className="home">
			{/** Home page heading */}
			<div className="home__heading">
				<h1>
					Enter the necessary information to generate your cv.
					<span
						className="btn btn__text-underline-primary"
						onClick={generateFromSample}>
						generate from sample
					</span>{" "}
					or{" "}
					<span className="btn btn__text-underline-dark" onClick={resetData}>
						start from scratch
					</span>
				</h1>
			</div>
			{/** Home top navigation and buttons */}
			<Navigation />

			{/** Home page inner route components */}
			<div className="home__inner">
				<Outlet />
			</div>
		</div>
	)
}

export default Home
